import {SetStateAction, Dispatch} from 'react'
import {handleEsc} from '../../lib'
import {selectTheme} from '../../store'
import {Legend, ButtonCancel, TextLink, Button} from '..'

export interface PopupConfirmArchiveTaskPropsT {
  closeAction: Dispatch<SetStateAction<boolean>>
  archiveAction: () => void
}

export const PopupConfirmArchiveTask = (props: PopupConfirmArchiveTaskPropsT) => {
  const {color} = selectTheme()

  const {closeAction, archiveAction} = props

  const handleCloseAction = () => {
    if (closeAction) closeAction(false)
  }

  const handleArchiveAction = () => {
    if (archiveAction) archiveAction()
  }

  handleEsc(handleCloseAction)

  const TaskArchiveNotice = () => {
    return (
      <div className='max-w-2xl mx-auto p-6 bg-white'>
        <div className='space-y-6'>
          <div>
            <h2 className='text-lg font-semibold text-gray-900 mb-4'>By archiving this task:</h2>

            <div
              css={{
                gap: '12px',
              }}>
              <div
                css={{
                  display: 'flex',
                  paddingLeft: '10px',
                  paddingTop: '6px',
                }}>
                <span
                  css={{
                    paddingRight: '10px',
                  }}>
                  •
                </span>
                <span>New participants will not see this task</span>
              </div>

              <div
                css={{
                  display: 'flex',
                  paddingLeft: '10px',
                  paddingTop: '6px',
                }}>
                <span
                  css={{
                    paddingRight: '10px',
                  }}>
                  •
                </span>
                <div>
                  Original participants will no longer see this task in the future(Past completions will still show up
                  in the history)
                </div>
              </div>

              <div
                css={{
                  display: 'flex',
                  paddingLeft: '10px',
                  paddingTop: '6px',
                }}>
                <span
                  css={{
                    paddingRight: '10px',
                  }}>
                  •
                </span>
                <span>
                  You will still see a record of task completion on adherence and this data will be downloaded for
                  participants that already completed this task.
                </span>
              </div>
            </div>

            <h2
              css={{
                paddingTop: '6px',
                paddingBottom: '20px',
              }}>
              <strong>Note:</strong> All changes made during this live edit session will be saved when you leave.
              Active. All changes made during this live edit session will be saved when you leave. If you want to keep
              any changes, first publish these changes before archiving.
            </h2>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      data-testid='task_confirm_delete_pop'
      css={{
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        background: '#00000040',
        zIndex: 99999,
      }}>
      <div
        css={{
          position: 'absolute',
          top: 'calc(50vh - 145px)',
          left: 'calc(50vw - 300px)',
          width: '600px',
          borderRadius: '5px',
          padding: '20px',
          background: color.white,
        }}>
        <div
          css={{
            display: 'flex',
            alignItems: 'top',
            justifyContent: 'space-between',
            position: 'relative',
          }}>
          <Legend
            css={{
              marginBottom: '16px',
            }}>
            Archive this task
          </Legend>

          <ButtonCancel onClick={handleCloseAction} size={'large'} />
        </div>

        {TaskArchiveNotice()}

        {/* divider */}
        <div css={{width: '100%', height: '1px', background: color.grey_60, marginBottom: '20px'}}></div>

        <div
          css={{
            width: '100%',
            display: 'flex',
            justifyContent: 'right',
          }}>
          <Button
            onClick={handleCloseAction}
            btnPadding='large'
            btnColor='grey_20'
            textColor={color.grey_600}
            children={'Cancel'}
          />
          <div css={{width: '12px'}} />
          <Button onClick={handleArchiveAction} btnPadding='large' btnColor='primary' children={'Archive this task'} />
        </div>
      </div>
    </div>
  )
}
